export const GOOGLE_MAP_LOADED_SUCCESS  = 'GOOGLE_MAP/GOOGLE_MAP_LOADED_SUCCESS';
export const GOOGLE_MAP_LOADED_ERROR    = 'GOOGLE_MAP/GOOGLE_MAP_LOADED_ERROR';